import { FC } from "react";
import { Box, Typography } from "@material-ui/core";
import { useIntl } from "../../../../../../_metronic/i18n/customUseIntl";
import { roiCalculatorStyles } from "../../../../../ThemeProvider";
import ReactHookDsmSelect from "../../../../../modules/Helpers/ReactHookDsmSelect2";

interface CurrencySectionProps {
  options: Array<{ text: string; value: string }>;
  readOnly: boolean;
}

const CurrencySection: FC<CurrencySectionProps> = ({ options, readOnly }) => {
  const intl = useIntl();
  const roiClasses = roiCalculatorStyles();

  return (
    <Box className={roiClasses.sectionColumn}>
      <Typography variant="h6" className={roiClasses.sectionTitle}>
        {intl.formatMessage({
          id: "SUSTELL.ROI.CURRENCY_SECTION.TITLE",
        })}
      </Typography>

      <Box className={roiClasses.currencySelectBox}>
        <ReactHookDsmSelect
          name="currency"
          label={intl.formatMessage({
            id: "SUSTELL.ROI.CURRENCY_SECTION.LABEL",
          })}
          placeholder={intl.formatMessage({
            id: "SUSTELL.ROI.CURRENCY_SECTION.PLACEHOLDER",
          })}
          options={options}
          required
          displayEmpty
          disabled={readOnly}
          style={{ width: "100%" }}
        />
      </Box>
    </Box>
  );
};

export default CurrencySection;
